import { useEffect, useState } from "react";
import { useCanEdit } from "@/lib/app-context";

export function MoneyInput({ value, onCommit, testId, className = "" }) {
  const canEdit = useCanEdit();
  const [v, setV] = useState(String(value));
  useEffect(() => { setV(String(value)); }, [value]);
  const commit = () => {
    const n = Number(v || 0);
    if (Number.isNaN(n) || n < 0) return setV(String(value));
    if (n !== value) onCommit(n);
  };
  return (
    <input
      type="number"
      inputMode="decimal"
      min="0"
      value={v}
      readOnly={!canEdit}
      onChange={(e) => setV(e.target.value)}
      onBlur={commit}
      onKeyDown={(e) => e.key === "Enter" && e.currentTarget.blur()}
      className={`num-input w-full bg-transparent rounded-md px-2 py-1.5 border border-transparent ${canEdit ? "hover:border-slate-200 focus:border-teal-500 focus:bg-teal-50/60" : "cursor-default"} focus:outline-none transition-colors ${className}`}
      data-testid={testId}
    />
  );
}
